import { createSelector } from '@ngrx/store';
import { AccountTypes, FilteredAccount } from '@shared/models';
import {
  selectEligibleGiftingAccounts,
  selectEligibleJointAccounts,
} from '@store/selectors/client-accounts/client-accounts.selectors';
import { selectAccountType } from '@store/selectors/triage/triage.selectors';

export const selectGiftingEligibility = createSelector(
  selectAccountType,
  selectEligibleJointAccounts(),
  selectEligibleGiftingAccounts(AccountTypes.INDV),
  selectEligibleGiftingAccounts(AccountTypes.TRUST),
  (accountType, eligibleJointAccounts, eligibleIndvAccounts, eligibleTrustAccounts) => {
    const accountFromType: AccountTypes = accountType ?? AccountTypes.EMPTY;

    const isJointAccountType =
      accountFromType === AccountTypes.JOINT || accountFromType === AccountTypes.JOINT_TENANTS_WROS;
    const isGiftingEligible: boolean =
      (accountFromType === AccountTypes.INDV && eligibleIndvAccounts.accounts.length >= 1) ||
      (isJointAccountType && eligibleJointAccounts.accounts.length >= 1) ||
      (accountFromType === AccountTypes.TRUST && eligibleTrustAccounts.accounts.length >= 1);

    let filterAccounts: FilteredAccount[] = [];

    if (isGiftingEligible) {
      switch (accountFromType) {
        case AccountTypes.INDV:
          filterAccounts = eligibleIndvAccounts.accounts;
          break;
        case AccountTypes.JOINT:
        case AccountTypes.JOINT_TENANTS_WROS:
          filterAccounts = eligibleJointAccounts.accounts;
          break;
        case AccountTypes.TRUST:
          filterAccounts = eligibleTrustAccounts.accounts;
          break;
      }
    }

    return {
      isGiftingEligible,
      accountFromType,
      filterAccounts,
    };
  },
);
